class OnBoardingContentController {
    constructor(settings, analyticsService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.bannerUrl = this.settings.onBoarding.bannerImageUrl;
        this.content = this.settings.onBoarding.content;
        this.dialogCtrl.show();
    }
}

const onBoardingContentComponentDefinition = {
    controller: ['Settings', 'AnalyticsService', OnBoardingContentController],
    require: { dialogCtrl: '^dialog' },
    template: require('./onboarding-dialog-content.component.html').trim(),
};

module.exports = {
    OnBoardingContentController,
    onBoardingContentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/onboarding/onboarding-dialog-content.component.js